/**
 * @note: this is only used for vegetation simulations
 */

import usePage from "./usePage";
import useFetch from "hooks/useFetch";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function useRun() {
  const { runId, isVegetationPage, isUrbanPage, projectId, isSharePage } =
    usePage();
  const [currRun, setCurrRun] = useState(null);
  const navigate = useNavigate();
  const prefix = isSharePage ? "/hash" : "";

  const { data: currRunData, isLoading: isRunLoading } = useFetch(
    `${prefix}/simulation/pathway/${runId}`,
    {},
    !!runId && isVegetationPage
  );

  useEffect(() => {
    if (currRunData?.details) {
      var cr = currRunData?.details;
      cr.name = currRunData?.name || "";
      setCurrRun(cr);
    }
  }, [currRunData, setCurrRun]);

  useEffect(() => {
    if (!runId) {
      setCurrRun(null);
    }
  }, [runId, setCurrRun]);

  const setRunId = (runId) => {
    if (runId) {
      navigate(`${prefix}/simulation/${runId}`);
    } else {
      navigate(`${prefix}/project/${projectId}${isUrbanPage ? "/urban" : ""}`);
    }
  };

  return { currRun, isRunLoading, setCurrRun, setRunId };
}
